import { Back } from "@/ui/Back";
import { Buttons } from "@/ui/Buttons";
import cn from "classnames";
import { Card, Container, Ratio } from "react-bootstrap";
import { Parallax } from "react-scroll-parallax";
import { format } from "date-fns";

import bg_1 from "./bg_1.webp";
import classes from "./styles.module.scss";

export default function ({
  className,
  featured,
  title,
  salary_package,
  updated_at,
  employment_types,
  working_options,
  external_reference,
  location,
  image = null,
  buttons = [{ label: "Apply Now", url: "#apply", variant: "blue" }],
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <Card className={cn(className, classes.JobPostHero)} data-bs-theme={theme}>
      <Parallax translateY={[-160, 100]}>
        {!image && <img src={bg_1} className={classes.bg_1} alt="" />}
        <Card.Img as={Ratio} aspectRatio={34}>
          <EditableImage path="image" src={image ?? "/assets/default_hero.webp"} size="1920x547" />
        </Card.Img>
      </Parallax>
      <Card.ImgOverlay className="d-flex flex-column text-center align-items-center justify-content-center pb-4 pb-md-5 pt-5">
        <Container fluid="md" className="pt-5 pb-md-5">
          <Back href="/jobs/" className="mb-4 mb-lg-0">Back to Job Search</Back>
          {featured && (
            <Card.Header className="small mb-4">
              <i /> Featured Job
            </Card.Header>
          )}
          <Card.Title as={EditableHtml} path="title" tag="h1">
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </Card.Title>
          <Card.Footer>
            <span className="d-flex gap-2">
              <i className="py-1 px-2">{external_reference}</i>
              {employment_types.map((e) => (
                <i key={e.id} className="py-1 px-2">
                  {e.name}
                </i>
              ))}
            </span>
            <span className="px-3 mx-2 border-start border-end">{salary_package}</span>
            <span className="px-3 mx-2  border-end">{working_options?.length ? working_options[0].value : "N/A"}</span>
            <span className="px-3 mx-2  border-end">{location}</span>
            <span>Updated on: {format(new Date(updated_at), "dd-MM-yyyy")}</span>
          </Card.Footer>
          {buttons && (
            <Buttons buttons={buttons} className="d-flex flex-row justify-content-center gap-3" />
          )}
        </Container>
      </Card.ImgOverlay>
    </Card>
  );
}
